import React, {useState, useCallback, useEffect} from 'react';
import {connect} from 'react-redux';

import {ApplicationStoreType} from 'reducers';
import Popup from 'components/__helpers/popup/popup';
import {usePrevious} from 'libs/hooks/usePrevious';

export type PropsType = {
    customPopup: {data: {content: string}; status: string; description: string};
};

/**
 * Dialog wrapper component for the root <App /> component
 * @constructor
 */
export const Dialog: React.FC<PropsType> = ({customPopup}) => {
    const [isVisible, setIsVisible] = useState(false);
    const prevStatus = usePrevious(customPopup.status);
    const contentPopup = customPopup?.data?.content || customPopup.description;

    useEffect(() => {
        if (prevStatus !== customPopup.status && customPopup.status === 'fulfilled') {
            setIsVisible(true);
        }
    }, [customPopup.status, prevStatus]);

    const closePopup = useCallback(() => {
        setIsVisible(value => !value);
    }, []);

    return (
        <Popup visible={isVisible} onClose={closePopup}>
            <div dangerouslySetInnerHTML={{__html: contentPopup}} />
        </Popup>
    );
};

const mapStateToProps = (store: ApplicationStoreType) => ({
    customPopup: store.customPopup,
});

export const DialogConnected = connect(mapStateToProps)(Dialog);
